function application(state = {
    error : null
}, action) {
    switch(action.type) {
        case 'APPLICATION_MESSAGE_SHOW' :
            if(state.timeout) {
                clearTimeout(state.timeout);
            }
            return {
                ...state,
                message : action.message,
                timeout : action.timeout
            }
        case 'APPLICATION_MESSAGE_HIDE' : 
            return  {
                ...state,
                message : null,
                timeout : null
            }
        case 'API_ERROR' :
            return {
                ...state,
                error : action.error,
            }
        case 'API_ERROR_CLEAR' :
            return {
                ...state,
                error : null,
            }
        default : 
            return state;
    }
}

export default application;


/** WEBPACK FOOTER **
 ** ./src/reducers/application.js
 **/